import { render, staticRenderFns } from "./pop-ups.vue?vue&type=template&id=3da9dace&scoped=true"
import script from "./pop-ups.vue?vue&type=script&lang=js"
export * from "./pop-ups.vue?vue&type=script&lang=js"
import style0 from "./pop-ups.vue?vue&type=style&index=0&id=3da9dace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da9dace",
  null
  
)

export default component.exports